import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineHeight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLineHeight"><Path d="M2.5 4.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 19.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 10L12 7.5L14.5 10" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 14L12 16.5L14.5 14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLineHeight;
